import * as React from 'react';
import { UIHeading4 } from '@cian/ui-kit/typography';
import * as styles from './Button.css';

type ButtonLinkProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  testId?: string;
};

export function ButtonLink(props: ButtonLinkProps) {
  const { href, children, testId } = props;

  return (
    <a className={styles['button']} href={href} target="_blank" rel="noreferrer" data-testid={testId}>
      <UIHeading4 color="text-inverted-default" fontWeight="bold">
        {children}
      </UIHeading4>
    </a>
  );
}
